<img [style.height]="height" [style.width]="width" [class.light]="color === 'light'" src="/assets/images/logo.svg" loading="lazy">
